<div class="bg-white w-96 max-w-[90vw] flex flex-col p-6 rounded-lg gap-4">
    <div class="flex flex-col gap-1 border-b pb-3">
        <div class="flex items-center justify-between gap-2">
            <span class="text-base font-semibold">Check List</span>
            @if (checkList.length > 0) {
            <span class="text-sm font-medium"
                [ngClass]="isAllChecked() ? 'text-lime-600' : 'text-gray-500'">
                {{ checkedCount }}/{{ checkList.length }}
            </span>
            }
        </div>
        @if (setName || setSku) {
        <div class="text-sm text-gray-600 break-words">
            @if (setSku) {
            <span class="text-primary-500 font-medium">{{ setSku }}</span>
            }
            @if (setSku && setName) {
            <span class="text-gray-400 mx-1">—</span>
            }
            @if (setName) {
            <span>{{ setName }}</span>
            }
        </div>
        }
    </div>
    <div class="flex flex-col w-full text-sm md:text-base">
        @if (checkList.length > 0) {
        <div class="w-full flex space-x-2 border-b pb-2 mb-4">
            <input type="checkbox" id="check-all-toggle"
                [checked]="isAllChecked()"
                [indeterminate]="isIndeterminate()"
                (change)="toggleAll($any($event.target).checked)" />
            <label for="check-all-toggle" class="font-medium cursor-pointer">เลือกทั้งหมด</label>
        </div>
        }
        <div class="flex flex-col gap-4 max-h-[50vh] overflow-y-auto pr-1">
            @for (item of checkList; track $index) {
            <div class="">
                <div class="w-full flex space-x-2">
                    <input type="checkbox" [name]="item.channel" [id]="item.channel" [(ngModel)]="item.checked"
                        class="" />
                    <label [for]="item.channel" class="cursor-pointer"
                        [ngClass]="{'line-through text-gray-500': item.checked}">{{item.name}}</label>
                </div>
                <div class="flex pl-7 space-x-2">
                    <div class="text-xs text-gray-500">{{getDateString(item.date)}}, {{getUserName(item.user_id)}}</div>
                </div>
            </div>
            }
        </div>
    </div>

    <div class="flex justify-end space-x-2 pt-3 border-t">
        <button mat-dialog-close class="btn-sm btn-light min-w-[6rem]" (click)="close()">
            ยกเลิก
        </button>
        <button class="btn-sm btn-primary min-w-[6rem]" (click)="confirm()">
            อัพเดต
        </button>
    </div>
</div>
